import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { authenticated: Boolean }

  connect() {
    if ("serviceWorker" in navigator) {
      if (this.authenticatedValue) {
        this.registerServiceWorker()
        this.setupTurboBroadcastListener()
      } else {
        // Clear any existing service workers if user is not authenticated
        this.clearExistingServiceWorkers()
      }
    }
  }

  async registerServiceWorker() {
    try {
      const registration = await navigator.serviceWorker.register("/service-worker.js", {
        scope: "/"
      })
      
      console.log("Service Worker registered successfully:", registration)
      
      // Listen for updates
      registration.addEventListener("updatefound", () => {
        console.log("Service Worker update found")
        const newWorker = registration.installing
        
        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "activated") {
            console.log("Service Worker updated and activated")
            // Optionally show a notification to the user
            this.showUpdateNotification()
          }
        })
      })
      
      // Request background sync permission
      if ("sync" in window.ServiceWorkerRegistration.prototype) {
        console.log("Background sync supported")
      }
      
    } catch (error) {
      console.error("Service Worker registration failed:", error)
    }
  }

  showUpdateNotification() {
    // You could show a toast notification here
    console.log("App has been updated in the background")
  }

  setupTurboBroadcastListener() {
    // Listen for Turbo broadcasts and notify the service worker to invalidate cache
    document.addEventListener('turbo:before-stream-render', async (event) => {
      console.log('Turbo stream detected, notifying service worker to invalidate cache')
      
      try {
        const registration = await navigator.serviceWorker.ready
        if (registration.active) {
          const messageChannel = new MessageChannel()
          
          messageChannel.port1.onmessage = (event) => {
            console.log('Service worker cache invalidation response:', event.data)
          }
          
          registration.active.postMessage({
            type: 'TURBO_BROADCAST',
            projectUrl: window.location.href,
            timestamp: Date.now()
          }, [messageChannel.port2])
        }
      } catch (error) {
        console.error('Failed to notify service worker:', error)
      }
    })

    // Also listen for general turbo refresh events
    document.addEventListener('turbo:reload', async () => {
      console.log('Turbo reload detected, clearing project cache')
      
      try {
        const registration = await navigator.serviceWorker.ready
        if (registration.active) {
          registration.active.postMessage({
            type: 'TURBO_BROADCAST',
            projectUrl: window.location.href,
            timestamp: Date.now()
          })
        }
      } catch (error) {
        console.error('Failed to notify service worker on reload:', error)
      }
    })
  }

  async clearExistingServiceWorkers() {
    try {
      console.log("User not authenticated, clearing existing service workers...")
      
      // Clear all caches
      if ("caches" in window) {
        const cacheNames = await caches.keys()
        const deletePromises = cacheNames.map(cacheName => {
          console.log("Clearing cache:", cacheName)
          return caches.delete(cacheName)
        })
        await Promise.all(deletePromises)
        console.log("All caches cleared")
      }

      // Unregister all service workers
      const registrations = await navigator.serviceWorker.getRegistrations()
      for (const registration of registrations) {
        console.log("Unregistering service worker:", registration.scope)
        await registration.unregister()
      }
      
      console.log("All service workers unregistered")
    } catch (error) {
      console.error("Error clearing existing service workers:", error)
    }
  }
}